export const kendoFilterOperatorList = [
    {
        operator: 'gt',
        label:    '>',
    },
    {
        operator: 'gte',
        label:    '>=',
    },
    {
        operator: 'lt',
        label:    '<',
    },
    {
        operator: 'lte',
        label:    '<=',
    },
    {
        operator: 'eq',
        label:    '=',
    },
    {
        operator: 'neq',
        label:    '<>',
    },
    {
        operator: 'contains',
        label:    'Contains',
    },
    {
        operator: 'doesnotcontain',
        label:    'Does Not Contain'
    },
    {
        operator: 'startswith',
        label:    'Starts With'
    },
    {
        operator: 'endswith',
        label:    'Ends With'
    },
    {
        operator: 'isempty',
        label:    'Is Emtpy'
    },
    {
        operator: 'isnotempty',
        label:    'Is Not Empty'
    },
    {
        operator: 'isnull',
        label:    'Is Null'
    },
    {
        operator: 'isnotnull',
        label:    'Is Not Null'
    }
];
